// extracted by mini-css-extract-plugin
export default {"dropDownG1G2Hidden":"dropDownG1G2Hidden___seC39"};